import { type OpenApiSchemaImportStocksSettings } from '../../api/schema';
import { type IntegrationSettings, type SupportedIntegrationSyncTypes } from './types';

export const isIntegrationSettingsForStocks = (
    syncType: SupportedIntegrationSyncTypes,
    data: IntegrationSettings | undefined
): data is OpenApiSchemaImportStocksSettings => Boolean(data && syncType === 'stocks');
